import { PartnerStorageLocation } from "./actions";

export enum LocalStorageConsts {
  CURRENT_STORAGE_LOCATION = "currentStorageLocation",
  CURRENT_PARTNER = "currentPartner",
  CURRENT_USER = "currentUser",
}

export type LocalStorageCurrentStorageLocation = Pick<PartnerStorageLocation, "name" | "id">;
